import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="w-full bg-gray-50 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-cyan-400 rounded-lg flex items-center justify-center">
                <i className="ri-search-line text-white text-lg"></i>
              </div>
              <span className="text-xl font-bold text-gray-900" style={{ fontFamily: 'Pacifico, serif' }}>QikFinder</span>
            </div>
            <p className="text-gray-600 text-sm">
              Find your things fast with our smart organization system.
            </p>
          </div>
          
          {/* Navigation */}
          <div className="space-y-4">
            <h4 className="font-semibold text-gray-900">Navigation</h4>
            <div className="space-y-2">
              <Link to="/" className="block text-gray-600 hover:text-gray-900 text-sm cursor-pointer">Home</Link>
              <Link to="/features" className="block text-gray-600 hover:text-gray-900 text-sm cursor-pointer">Features</Link>
              <Link to="/about" className="block text-gray-600 hover:text-gray-900 text-sm cursor-pointer">About</Link>
              <Link to="/contact" className="block text-gray-600 hover:text-gray-900 text-sm cursor-pointer">Contact</Link>
            </div>
          </div>
          
          {/* Features */}
          <div className="space-y-4">
            <h4 className="font-semibold text-gray-900">Features</h4>
            <div className="space-y-2">
              <div className="text-gray-600 text-sm">Item Registration</div>
              <div className="text-gray-600 text-sm">Fast Search</div>
              <div className="text-gray-600 text-sm">Space Management</div>
              <div className="text-gray-600 text-sm">Smart Organization</div>
            </div>
          </div>
          
          {/* Contact */}
          <div className="space-y-4">
            <h4 className="font-semibold text-gray-900">Contact</h4>
            <div className="space-y-2">
              <div className="text-gray-600 text-sm">support@qikfinder.com</div>
              <div className="text-gray-600 text-sm">Coming Soon</div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-200 pt-8 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-500 text-sm">
              © 2024 QikFinder. All rights reserved.
            </div>
            <div className="flex items-center space-x-4">
              <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-gray-600 text-sm cursor-pointer">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}